import FormReport from "../../../../../../components/pages/FormReport";
import { useFetch } from '../../../../../../hooks/useFetch';
import { exportCustomClearanceExcel } from '../customClearanceExcel';

export default () => {

    return (
        <FormReport
            title={'Custome Clearance Export'}
            repType={'daily_date'}
            url={"/api/v1/report_custome_clearance/export"}
            FetchComponent={useFetch}
            customExcelExport={exportCustomClearanceExcel}
        />
    )
}
